import { useMemo } from 'react'

const formatTimeFromSeconds = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')
  return `${formattedHours}:${formattedMinutes}`
}

const useShopTime = (openTime: number, closeTime: number) => {
  const { open, close } = useMemo(() => {
    const open = formatTimeFromSeconds(openTime)
    const close = formatTimeFromSeconds(closeTime)
    return { open, close }
  }, [ openTime, closeTime ])

  const getShopStatus = useMemo(() => {
    const now = new Date()
    const currentTimeInSeconds = now.getHours() * 3600 + now.getMinutes() * 60
    return currentTimeInSeconds >= openTime && currentTimeInSeconds < closeTime
  }, [ openTime, closeTime ])

  return { open, close, getShopStatus }
}

export default useShopTime
